import sortQuotesByReceivedAmount from './sortQuotesByReceivedAmount';
import {isWiseQuote} from "./quoteFilters";

function isWisePresentAndNotCheapest(quotes) {
  return (
    quotes.length &&
    quotes.find((p) => (isWiseQuote(p))) &&
    !isWiseQuote(sortQuotesByReceivedAmount(quotes)[0])
  );
}

export default isWisePresentAndNotCheapest;
